import { CHOICE_LABELS, CHOICE_FIELD } from './mapAttributeInputCallbackToComponent';
import { getCustomRegexpPolicy } from './extractPolicy';

const setFieldsToProfessional = () => {
  const genderNode = document.getElementsByName('custom_gender');
  setFieldChoices(genderNode, 'custom_gender_pro');
  setFieldsLastName('Raison sociale', true);
  setFieldsFirstName('Identité du destinataire', true);
  const birthDateNode = document.getElementsByName('custom_birthday');
  setFieldValue(birthDateNode, '');
  hideField(birthDateNode);
};

const setFieldsToPersonnal = () => {
  const genderNode = document.getElementsByName('custom_gender');
  setFieldChoices(genderNode, 'custom_gender');
  setFieldsLastName('Nom', false);
  setFieldsFirstName('Prénom', false);
  const birthDateNode = document.getElementsByName('custom_birthday');
  showField(birthDateNode);
};

const setFieldsLastName = (placeholder: string, isProfessional: boolean) => {
  const lastNameNode = document.getElementsByName('sn');
  setFieldPlaceholder(lastNameNode, placeholder);
  setFieldValue(lastNameNode, '');
  const patternLastName = getCustomRegexpPolicy('sn', isProfessional);
  patternLastName && setFieldPattern(lastNameNode, patternLastName);
};

const setFieldsFirstName = (placeholder = 'Identité du destinataire', isProfessional = true) => {
  const firstNameNode = document.getElementsByName('givenName');
  setFieldPlaceholder(firstNameNode, placeholder);
  setFieldValue(firstNameNode, '');
  const patternFirstName = getCustomRegexpPolicy('givenName', isProfessional);
  patternFirstName && setFieldPattern(firstNameNode, patternFirstName);
};

const setFieldChoices = (nodeElement: NodeListOf<HTMLElement>, key: string) => {
  if (nodeElement.length < 2) return;

  const labels = CHOICE_LABELS[key as CHOICE_FIELD];
  labels.forEach((label, index) => {
    const inputElement = nodeElement.item(index) as HTMLInputElement;
    const labelElement = inputElement.nextElementSibling as HTMLDivElement;
    if (!labelElement) return;

    labelElement.innerHTML = label;
  });
};
const setFieldPlaceholder = (nodeElement: NodeListOf<HTMLElement>, placeholder: string) => {
  if (nodeElement.length === 0 || !(nodeElement.item(0) instanceof HTMLInputElement)) return;

  const inputElement = nodeElement.item(0) as HTMLInputElement;
  const labelElement = inputElement.nextElementSibling as HTMLDivElement;
  if (!labelElement) return;

  const placeholderElement = labelElement.firstChild as HTMLSpanElement;
  if (!placeholderElement) return;

  placeholderElement.innerHTML = placeholder;
};
const setFieldValue = (nodeElement: NodeListOf<HTMLElement>, value: string) => {
  if (nodeElement.length === 0 || !(nodeElement.item(0) instanceof HTMLInputElement)) return;

  const inputElement = nodeElement.item(0) as HTMLInputElement;
  inputElement.value = value;
};
const setFieldPattern = (nodeElement: NodeListOf<HTMLElement>, pattern: string) => {
  if (nodeElement.length === 0 || !(nodeElement.item(0) instanceof HTMLInputElement)) return;

  const inputElement = nodeElement.item(0) as HTMLInputElement;
  inputElement.pattern = pattern;
};
const hideField = (nodeElement: NodeListOf<HTMLElement>) => toggleFieldVisibility(nodeElement, false);
const showField = (nodeElement: NodeListOf<HTMLElement>) => toggleFieldVisibility(nodeElement, true);
const toggleFieldVisibility = (nodeElement: NodeListOf<HTMLElement>, visible: boolean) => {
  if (nodeElement.length === 0 || !(nodeElement.item(0) instanceof HTMLInputElement)) return;

  const inputElement = nodeElement.item(0) as HTMLInputElement;
  const labelElement = inputElement.parentElement as HTMLLabelElement;
  if (!labelElement) return;

  labelElement.style.display = visible ? '' : 'none';
};

export const professionalAccountService = {
  setFieldsToProfessional,
  setFieldsToPersonnal,
};
